import calcShortcutInterval, {
  calcShortcutIntervalWithinBoundary,
} from '@utils/calcShortcutInterval';
import { DATE_SHORTCUTS } from '@utils/constants';
import { useEventListForCreateMetric } from '@src/emp-3.0/api/queryHooks';
import { useCallback } from 'react';
import { find } from 'lodash';
import { ESystemType } from '@src/emp-3.0/types';

export const useGetEventNameById = () => {
  const [from, to] = calcShortcutIntervalWithinBoundary(DATE_SHORTCUTS.last7Days, ESystemType.EMP);
  const {
    data: eventListIncludeRaw = [],
    isLoading,
    refetch: refetchEventList,
  } = useEventListForCreateMetric({
    interval: `${from.format()}/${to.format()}`,
  });

  const refetch = () => {
    refetchEventList();
  };

  const getMappedEventNameById = useCallback(
    (id: number | string | undefined) => {
      // raw event no id, return raw event name
      if (id === undefined) {
        return id;
      }

      const findNameById = (
        list: any[],
        id: number | string | undefined,
      ): string | number | undefined => {
        if (!id) return id;
        const matchedEvent = find(list, (event) => event?.id === id || event?.event_id === id);
        return matchedEvent ? matchedEvent.name || matchedEvent.event_name : id;
      };

      return findNameById(eventListIncludeRaw, id);
    },
    [eventListIncludeRaw],
  );
  return { getMappedEventNameById, isLoading, refetch };
};
